import { throwUa } from "./errors";
import { supabase } from "./supabase";
import { PartnerProfile, ProfileUpdate } from "../models/account";

export const isValidPhone = (phone: string): boolean =>
  /^\+?[0-9\s()-]{7,20}$/.test(phone.trim());

export const updateProfile = async (
  update: ProfileUpdate
): Promise<PartnerProfile> => {
  const { data: userData } = await supabase.auth.getUser();
  if (!userData.user) throw new Error("Потрібно увійти в акаунт");

  const { data, error } = await supabase
    .from("profiles")
    .update(update)
    .eq("id", userData.user.id)
    .select("*")
    .single<PartnerProfile>();
  if (error || !data) throwUa(error);
  return data as PartnerProfile;
};
